import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import RoutesItems from '../../../../Routes/RoutesItems';
import useMatchedRoute from '../../../../Utils/Routes/useMatchedRoute';

import Loader from '../Loader/Loader';
/**
 * This component is user as middleware on routes
 * @returns {React.ReactElement} Route outlet or auth redirect state
 */

const AuthGaurd = () => {
  const route = useMatchedRoute(RoutesItems);
  const location = useLocation();
  const { checkTokens, canAccessRoute, isLoading } = useAuth();

  /**
   * if Auth gaurd is Active on route and user is authenticated then it will open the requested component otherwise it will redirect to login splash scree
   * and if Auth gaurd is not Active then it will open the requested component with authenticate the user.
   */
  if (route?.isauth) {
    if (isLoading) {
      return (
        <div className="relative min-h-screen">
          <Loader />
        </div>
      );
    }

    if (!checkTokens()) {
      const redirectTo = `${location.pathname}${location.search}${location.hash}`;
      return (
        <Navigate
          to={`/login?redirectTo=${encodeURIComponent(redirectTo)}`}
          replace
        />
      );
    }

    if (!canAccessRoute(route)) {
      return <Navigate to="/no-permission" replace />;
    }
  }
  return <Outlet />;
};

export default AuthGaurd;
